import { styled, Button } from '@mui/material';

export const Actions = styled(Button)<{ noBorderRadius?: boolean }>(
  ({ noBorderRadius }) => ({
    order: 70,
    borderRadius: noBorderRadius ? 4 : 16,
    padding: '4px 16px',
  })
);
